// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropzone {
  position: relative;
  height: 200px;
  width: 100%;
  border: 2px dashed #D1D5DB;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dropzone input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
}
.dropzone label {
  color: #1F2937 !important;
}
.dropzone label u {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/file-upload/file-upload.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;AAAE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AAEJ;AAAE;EACE,yBAAA;AAEJ;AADI;EACE,0BAAA;AAGN","sourcesContent":[".dropzone {\n  position: relative;\n  height: 200px;\n  width: 100%;\n  border: 2px dashed #D1D5DB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  input{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    opacity: 0;\n  }\n  label{\n    color: #1F2937 !important;\n    u{\n      text-decoration: underline;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
